import { render, staticRenderFns } from "./GardenCard.vue?vue&type=template&id=cd162392&scoped=true"
import script from "./GardenCard.vue?vue&type=script&lang=ts"
export * from "./GardenCard.vue?vue&type=script&lang=ts"
import style0 from "./GardenCard.vue?vue&type=style&index=0&id=cd162392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd162392",
  null
  
)

export default component.exports